import React from 'react';
import { Row, Col, Card as RBCard } from "react-bootstrap";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import TimelineIcon from "@mui/icons-material/Timeline";
import { Avatar, Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../../utils/path';

const NationalCards = ({ data, stateWiseData }) => {
    const navigate = useNavigate();

    const cardsJson = [
        {
            title: "Total TCCC",
            indicatorKey: "MI_facilities",
            icon: <ApartmentIcon sx={{ color: "#6C7FF9" }} />,
            navigationType: 'tccc'
        },
        {
            title: "Total DCCC",
            indicatorKey: "DCCC_facilities",
            icon: <BusinessIcon sx={{ color: "#6C7FF9" }} />,
            navigationType: 'dccc'
        },
        {
            title: "Total Registered Beneficiaries",
            indicatorKey: "total_patients",
            icon: <GroupsIcon sx={{ color: "#6C7FF9" }} />,
            navigationType: 'beneficiaries'
        },
        {
            title: "Total Completed Chemo Sessions",
            indicatorKey: "total_chemo",
            icon: <TimelineIcon sx={{ color: "#6C7FF9" }} />,
            navigationType: 'chemo'
        }
    ];

    const handleNavigation = (type) => {
        navigate(
            `${paths?.user?.commonPoint}${paths?.user?.adminStatewiseStats}`,
            {
                state: {
                    type: type,
                    stateWiseData: stateWiseData
                }
            }
        );
    };

    return (
        <Row className="mt-3" xs={1} sm={2} lg={4}>
            {cardsJson.map((card, index) => (
                <Col className="mb-3" key={index}>
                    <RBCard className="shadow-sm border-0 rounded-4">
                        <RBCard.Body>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Typography variant="body2" color="gray">
                                    {card?.title}
                                </Typography>

                                <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                    {card?.icon}
                                </Avatar>
                            </Box>

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={4}
                            >
                                <Typography variant="h5" fontWeight={600}>
                                    {data?.[card?.indicatorKey] || "0"}
                                </Typography>

                                {(card?.navigationType === "tccc" || card?.navigationType === "dccc") && (
                                    <Button
                                        variant="outlined"
                                        className='viewBtnAdmin'
                                        onClick={() => handleNavigation(card?.navigationType)}
                                    >
                                        View
                                    </Button>
                                )}

                            </Box>
                        </RBCard.Body>
                    </RBCard>
                </Col>
            ))}
        </Row>
    )
}

export default NationalCards